import * as Config from '../../../config';
import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";

import ButtonIcon from '../common/ButtonIcon';
import IconCheck from "../svg/IconCheck";
import IconInvite from './svg/IconInvite';

import { addToast } from "../../../actions/index";

function ButtonInvite() {
  const dispatch = useDispatch();
  const inRoomPM = useSelector(state => state.inRoomPM);
  const isHost = useSelector(state => !!(state.inRoomPM && state.user && state.inRoomPM.owner === state.user.id));
  const isWatcher = useSelector(state => state.isWatcherPM);
  const nbPlayers = (inRoomPM) ? inRoomPM.players.filter(x => x.active).length : 0;

  const [isClick, setClick] = useState(false);
  const onClick = async () => {
    if (inRoomPM) {
      setClick(true);
      setTimeout(() => { setClick(false) }, 2000);
      dispatch(addToast({ content: <span>DJ Invite copied to clipboard</span>, iconStyle: { padding: '24px 16px', marginRight: 16 } }));
      await navigator.clipboard.writeText(`${window.location.origin}/pm/dj/${inRoomPM.ownername}/${inRoomPM.id}/${inRoomPM.tokenA}`);
    }
  }
  return (inRoomPM && isHost && (nbPlayers < Config.PM_MAX_ACTIVES) )
    ? <ButtonIcon className={`button-invite-V2`}
        icon={isClick ? <IconCheck className={`no-fill`} size={24} color={Config.BRAND_PRIMARY} /> : <IconInvite color={Config.BRAND_PRIMARY} />}
        label={isClick ? `Copied` : 'Add DJ'}
        classNameLabel={`type-medium fz13 brand-primary ${isClick && 'no-hover'}`}
        onClick={onClick}
      />
    : ((inRoomPM && !isWatcher)
      ? <ButtonIcon className={`button-invite-V2 type-disable`}
          icon={<IconInvite color={Config.TYPE_DISABLE} />}
          label={'Add DJ'}
          classNameLabel={`type-medium fz13 type-disable`}
          onClick={null}
        />
      : null
    );
}

export default ButtonInvite;
